module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-chrome",
    class: {
      'suspended': _vm.isTeamSuspend, 'th': _vm.isLangTH
    }
  }, [(_vm.isLoadingCurrentUser) ? _c('loading-indicator') : _c('div', [(_vm.isTeamSuspend) ? _c('div', {
    staticClass: "alert alert-social alert-linkedin alert-suspend"
  }, [_c('div', {
    staticClass: "container-fulid"
  }, [_c('h4', [_c('i', {
    staticClass: "icon md-notifications",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Your Account has been suspend.\n        "), (_vm.currentUser.team.suspend.suspend_reason) ? _c('span', {
    staticClass: "font-size-14 p-l-10"
  }, [_vm._v(_vm._s(_vm.currentUser.team.suspend.suspend_reason))]) : _c('span', {
    staticClass: "font-size-14 p-l-10"
  }, [_vm._v("Your credit isn't enough. Please add your credit now")]), _vm._v(" "), (!_vm.currentUser.team.suspend.suspend_reason) ? _c('router-link', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/billing#addcreditSection"),
      "alt": "Add credit"
    }
  }, [_vm._v(" Add credit\n         ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('nav-bar'), _vm._v(" "), (_vm.isUnauthorize) ? _c('page403') : _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "site-footer"
  }, [_c('div', {
    staticClass: "site-footer-legal"
  }, [_vm._v("© 2017 "), _c('a', {
    attrs: {
      "href": "http://byteark.com"
    }
  }, [_vm._v("ByteArk")]), _vm._v(" All Rights Reserved. ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-532e47a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chromes/AppChrome.vue
// module id = 532
// module chunks = 1